export enum ApplicantType {
  COTENANT = 'COTENANT',
  TENANT = 'TENANT',
}
